<article class="grid-wrapper">
  @if (loading()) {
  <div class="state-row">
    <div class="spinner-wrapper">
      <app-spinner size="m" type="ripple" />
      <p>{{ 'pages.accounts.states.loading' | translate }}</p>
    </div>
  </div>
  } @else if (accounts().length === 0) {
  <div class="state-row">
    <span>{{ 'pages.accounts.states.empty' | translate }}</span>
  </div>
  } @else {
  <app-responsive-table
    [items]="accounts()"
    [columns]="columns()"
    [actions]="actions()"
    [maxInlineActions]="3"
    [trackBy]="trackByAccount"
    (actionSelected)="onActionSelected($event)"
    [paginated]="true"
    [page]="pageNumber()"
    [pageSize]="pageSize()"
    [totalItems]="totalItems()"
    (pageChange)="onPageChange($event)"
  />
  }
</article>
